import { useState } from "react";
import "./Contact.scss";
import { sendMail } from "../utils/sendMail";

const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !email || !message) {
      setResult("すべて入力してください。");
      return;
    }

    setSending(true);
    setResult("");

    try {
      await sendMail({
        subject: `【ご興味のご連絡】${name}`,
        body: `
お名前：
${name}

メールアドレス：
${email}

メッセージ内容：
${message}
        `,
      });

      setResult("送信しました。ありがとうございます。");
      setName("");
      setEmail("");
      setMessage("");
    } catch (e) {
      setResult("送信に失敗しました。時間を置いて再度お試しください。");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="contact">
      <h1 className="contact__title">
        ご興味をお持ちいただけた方
        <br />　 お仕事の相談がなさりたい方へ
      </h1>

      <p className="contact__lead">
        私の取り組みにご興味をお持ちの方、想いに共感してくださる方は、
        ぜひお気軽にご連絡ください。
        <br />
        また、当サイトで紹介している私の仕事やスキルについて、
        ご依頼・ご相談をされたい方もお気軽にご連絡いただけると幸いです。
      </p>

      <form className="contact__form" onSubmit={handleSubmit}>
        <label>
          お名前
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </label>

        <label>
          メールアドレス
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </label>

        <label>
          メッセージ（参加のご希望・ご相談内容など）
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </label>

        <button type="submit" disabled={sending}>
          {sending ? "送信中..." : "送信する"}
        </button>

        {result && <p className="contact__result">{result}</p>}
      </form>
    </div>
  );
};

export default Contact;
